import type { FunctionComponent } from "react";

import { AddingTopicsAndAuthors } from "scmp-app/components/my-news/adding-topics-and-authors";
import { MyNewsInitFollowPackages } from "scmp-app/components/my-news/init-follow-packages";
import { SettingUpAlert } from "scmp-app/components/my-news/setting-up-alert";
import { WhatIsMynews } from "scmp-app/components/my-news/what-is-mynews";
import type { TopicPackage } from "scmp-app/pages/mynews/types";

import { StyledMynewsHeader } from "./styles";

type Props = {
  topicPackages: TopicPackage[];
};

export const InitMynews: FunctionComponent<Props> = ({ topicPackages }) => (
  <>
    <StyledMynewsHeader />
    <MyNewsInitFollowPackages topicPackages={topicPackages} />
    <WhatIsMynews />
    <AddingTopicsAndAuthors />
    <SettingUpAlert isShowSetupButton />
  </>
);

InitMynews.displayName = "InitMynews";
